import { RootState } from 'src/store/store'
import { useLocation } from 'react-router-dom'
import { ExplorerDetailDataPropsType } from 'src/views/Service/Explorer/Detail'
import ExplorerHeader from 'src/components/atomic/organisms/views/Explorer/ExplorerHeader'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import ExplorerDetailContents from 'src/components/atomic/organisms/views/Explorer/Detail/ExplorerDetailConents'
import ExplorerDetailPagination from 'src/components/atomic/organisms/views/Explorer/Detail/ExplorerDetailPagination'
import Spinner from 'src/components/atomic/atom/Spinner'
import Div from 'src/components/atomic/atom/Div'
import Span from 'src/components/atomic/atom/Span'
import Section from 'src/components/atomic/atom/Section'
import CheckBox from 'src/components/atomic/atom/CheckBox'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import Button from 'src/components/atomic/atom/Button'
import { COLOR } from 'src/constants/colors'
import { useTranslation } from 'react-i18next'
import Svg from 'src/components/atomic/atom/Svg'
import EmptyComponent from 'src/components/atomic/Molecules/EmptyComponent'

const ExplorerDetailTemplate = (props: { data: ExplorerDetailDataPropsType }) => {
  const {
    backUpRequestHandler,
    backupBtnDisabled,
    directoryPathHandler,
    selectedFileInfoHandler,
    fileDataTotalValue,
    allCheckboxChange,
    allCheckValid,
    curPage,
    setCurPage,
    arrayCheckList,
  } = props.data
  const title = useLocation()?.state?.Title
  const { t } = useTranslation()
  const { setMediaStyle } = useMediaQueryHook()
  const { DirTotal, FileTotal, FileInfos, Path } = useAppSelector(
    (state: RootState) => state.explorerFileList,
  )
  const { ExplorerFileListLoading } = useAppSelector((state: RootState) => state.ExplorerPage)

  const ExplorerTopFileInfo = () => {
    return (
      <Div
        display={'flex'}
        $align_item={'center'}
        $justify_content={'space-between'}
        height={'32px'}
        $margin={setMediaStyle('0 0 15px 3px', '16px 0', '16px 0')}
      >
        {!!Path ? <Svg name={'file_black'} width={'32'} $margin={'0 8px 0 0'} /> : null}
        <Span option={'small'} $text_align={'left'}>
          {fileDataTotalValue?.checkItemsSize === 0 && !!Path
            ? directoryPathHandler()
            : selectedFileInfoHandler()}
        </Span>
        {FileInfos?.length !== 0 ? (
          <Section display={'flex'} $gap={setMediaStyle('8px', '12px', '8px')}>
            <Span option={setMediaStyle('mini', 'tiny')} $line_height={'22px'}>
              All
            </Span>
            <CheckBox size={'22px'} checked={allCheckValid} onChange={allCheckboxChange} />
          </Section>
        ) : null}
      </Div>
    )
  }

  const ExplorerOfflineComponent = () => {
    return (
      <>
        <ExplorerTopFileInfo />
        <EmptyComponent
          option={'ExplorerOffline'}
          button={true}
          $margin={setMediaStyle('187px auto 0 auto', '95px auto 0 auto', '95px auto 0 auto')}
        />
      </>
    )
  }

  const ExplorerDataEmptyComponent = () => {
    return (
      <>
        <ExplorerTopFileInfo />
        <EmptyComponent
          option={'ExplorerNoData'}
          button={false}
          $margin={setMediaStyle('187px auto 0 auto', '95px auto 0 auto', '95px auto 0 auto')}
        />
      </>
    )
  }

  const ExplorerDetailDefaultComponent = () => {
    return (
      <>
        <ExplorerTopFileInfo />
        <ExplorerDetailContents data={props.data} />
        <ExplorerDetailPagination data={props.data} />
        <Button
          option={'bigDefault'}
          $bgColor={COLOR.brand}
          $margin={'0 0 50px 0'}
          onClick={backUpRequestHandler}
          disabled={backupBtnDisabled || arrayCheckList?.length === 0}
          className={'explorer_backup'}
        >
          <Span option={'medium_bold'} color={COLOR.white}>
            {t('BUTTON.FILE_BACK_UP', { defaultValue: 'Back up' })}
          </Span>
        </Button>
        <Div
          display={'flex'}
          $gap={'8px'}
          $justify_content={'center'}
          $margin={'-38px auto 18px auto'}
        >
          <Svg name={'notice_icon'} width={'18'} height={'18'} color={COLOR.blue} />
          <Span option={'tiny'} width={'unset'} color={COLOR.blue}>
            {t('EXPLORER_MAXSIZE_DOWN_CAPACITY', {
              defaultValue: 'Up to 30 selected, total 300MB capacity',
            })}
          </Span>
        </Div>
      </>
    )
  }

  const ExplorerContentsComponent = () => {
    const notDir = !DirTotal || DirTotal === 0

    switch (true) {
      case ExplorerFileListLoading:
        return <Spinner $height={'700px'} />
      case FileTotal === null:
        return <ExplorerOfflineComponent />
      case FileTotal === 0 && notDir:
        return <ExplorerDataEmptyComponent />
      default:
        return <ExplorerDetailDefaultComponent />
    }
  }

  return (
    <>
      <ExplorerHeader
        text={title}
        $margin={'35px auto 22px auto'}
        curPage={curPage}
        setCurPage={setCurPage}
      />
      {ExplorerContentsComponent()}
    </>
  )
}
export default ExplorerDetailTemplate
